import { Card, Title, Icon } from "@introist/react-foundation/v2";
import styled from "styled-components";
import { PerformanceReviewAggregateStats } from "../hooks/usePerformanceReviewData";

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: var(--spacing-medium);
`;

const StatCard = styled(Card)<{ $variant?: "default" | "danger" | "warning" | "success" }>`
  padding: var(--spacing-large);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
  border-left: 4px solid ${({ $variant }) => {
    switch ($variant) {
      case "danger":
        return "var(--palette-danger-default)";
      case "warning":
        return "var(--palette-warning-default)";
      case "success":
        return "var(--palette-success-default)";
      default:
        return "var(--palette-primary-default)";
    }
  }};
`;

const StatHeader = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
  color: var(--palette-text-secondary);
`;

const StatValue = styled.div`
  font-size: 2rem;
  font-weight: 700;
  line-height: 1;
  color: var(--palette-text-primary);
`;

const StatSubtext = styled.div`
  font-size: 0.875rem;
  color: var(--palette-text-secondary);
`;

type PerformanceReviewOverviewCardsProps = {
  stats: PerformanceReviewAggregateStats;
  activeInterventions?: number;
};

export const PerformanceReviewOverviewCards = ({
  stats,
  activeInterventions = 0
}: PerformanceReviewOverviewCardsProps) => {
  return (
    <CardsGrid>
      <StatCard $variant="warning">
        <StatHeader>
          <Icon name="warning" style={{ fontSize: 20 }} />
          <Title>Overdue Reviews</Title>
        </StatHeader>
        <StatValue>{stats.overdueCount}</StatValue>
        <StatSubtext>No review in the last 12 months</StatSubtext>
      </StatCard>

      <StatCard $variant="danger">
        <StatHeader>
          <Icon name="exclamationCircle" style={{ fontSize: 20 }} />
          <Title>High Priority Cases</Title>
        </StatHeader>
        <StatValue>{stats.highSeverityCount}</StatValue>
        <StatSubtext>Requiring immediate attention</StatSubtext>
      </StatCard>

      <StatCard $variant="default">
        <StatHeader>
          <Icon name="persons" style={{ fontSize: 20 }} />
          <Title>Never Reviewed</Title>
        </StatHeader>
        <StatValue>{stats.neverReviewedCount}</StatValue>
        <StatSubtext>Tenured 6+ months, no review held</StatSubtext>
      </StatCard>

      <StatCard $variant={activeInterventions > 0 ? "success" : "default"}>
        <StatHeader>
          <Icon name="workflows" style={{ fontSize: 20 }} />
          <Title>Workflows Launched</Title>
        </StatHeader>
        <StatValue>{activeInterventions}</StatValue>
        <StatSubtext>Review workflows started this session</StatSubtext>
      </StatCard>
    </CardsGrid>
  );
};
